import React from "react";
import { useDeal } from "../lib/store";
import { Tile, ScenarioBar, ScopeTag } from "../components/shared";
import { ReturnsBody } from "../components/ReturnsBody";
import { qsbsBump } from "../components/room/Qsbs";
import { AuditBadge } from "../components/AuditBadge";
import * as m from "../lib/model";

export default function Returns() {
  const { M, V, scope, scenario, setScenario, patch, navigate, scenFlash } = useDeal();
  const SM = V;                      // V already carries the app-wide case (base / upside / downside)
  const consolidated = m.isRollupScope(SM);
  const viewTag = m.scopeLabel(M, scope);
  const rows = m.model5yr(SM);
  const ex = m.exitReturns(SM);
  const dscr = m.dscrYr1(SM);
  const bump = qsbsBump(SM);

  return (
    <div className={`page ${scenFlash ? "scen-flash" : ""}`} data-testid="page-returns">
      <div className="page-head" style={{ display: "flex", justifyContent: "space-between", alignItems: "center", flexWrap: "wrap", gap: 12 }}>
        <div><div className="page-title">Returns{viewTag && <span className="view-tag" data-testid="returns-view-tag">{viewTag}</span>}</div><div className="page-sub">{consolidated ? "Consolidated roll-up — platform plus every add-on, phased by acquisition year" : scope.startsWith("addon:") ? `${SM.companyName} underwritten standalone at the roll-up terms` : "Pro forma cash flow, wealth build & value creation bridge"}</div></div>
        <div className="head-ctls"><AuditBadge V={SM} /><ScopeTag M={M} value={scope} onEdit={() => navigate("assumptions")} testid="returns-scope" /><ScenarioBar value={scenario} onChange={setScenario} /></div>
      </div>

      <div className="grid g4" style={{ marginBottom: 16 }}>
        <Tile label="Deal IRR" value={isNaN(ex.irr) ? "n/a" : m.fmtPct(ex.irr)} tone="go"
          sub={bump && bump.bps > 0 ? `QSBS +${bump.bps} bps after tax` : undefined} testid="ret-irr" />
        <Tile label="Equity MOIC" value={m.fmtX(ex.moic)} tone="go"
          sub={bump ? `QSBS +${m.fmtX(bump.x)} after tax` : undefined} testid="ret-moic" />
        <Tile label="Free Cash Flow Yr 1" value={m.fmt$(rows[0].fcf)} tone="go" testid="ret-fcf" />
        <Tile label="DSCR Year 1" value={m.fmtX(dscr)} tone="go" testid="ret-dscr" />
      </div>

      <ReturnsBody M={M} V={SM} scenario={scenario} patch={patch} onNavigate={navigate} />
    </div>
  );
}
